// removed by extract-text-webpack-plugin
module.exports = {"with-ellipsis":"SlideMenu_with-ellipsis---sb","withEllipsis":"SlideMenu_with-ellipsis---sb","menu-wrapper":"SlideMenu_menu-wrapper---sb","menuWrapper":"SlideMenu_menu-wrapper---sb","unFixed":"SlideMenu_unFixed---sb","rtl":"SlideMenu_rtl---sb","visible":"SlideMenu_visible---sb","menu":"SlideMenu_menu---sb","menu-btn-wrapper":"SlideMenu_menu-btn-wrapper---sb","menuBtnWrapper":"SlideMenu_menu-btn-wrapper---sb","menu-btn":"SlideMenu_menu-btn---sb","menuBtn":"SlideMenu_menu-btn---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SlideMenu/styles.less
// module id = 1630
// module chunks = 0